export const THIRD_PARTY_ANALYTICS_DOCUMENT_MARKER =
  "__offlico_third_party_analytics_present__";

export function markThirdPartyAnalyticsPresent() {
  if (typeof window === "undefined") return;
  window[THIRD_PARTY_ANALYTICS_DOCUMENT_MARKER] = true;
}

export function hasThirdPartyAnalyticsPresent() {
  return (
    typeof window !== "undefined" &&
    window[THIRD_PARTY_ANALYTICS_DOCUMENT_MARKER] === true
  );
}
